"use client"

import type { ReactNode } from "react"
import { notFound } from "next/navigation"
import { Skeleton } from "@ui/shad"

import { useFetchCurrentUser } from "@/hooks/api/users"

export function AuditLogAccess({ children }: { children: ReactNode }) {
  const user = useFetchCurrentUser()
  if (user.isPending) return <Skeleton className="m-4 h-48" />
  if (!user.data?.capabilities.includes("view_audit_log")) notFound()
  return children
}

export function AuditLogEntry({ children }: { children: ReactNode }) {
  const { data: user } = useFetchCurrentUser()
  return user?.capabilities.includes("view_audit_log") ? children : null
}
